import { useCallback, useEffect,useState } from "react"
import { postRequest } from "../../utils/ApiUtil"
import { apiEndpoints,appConfigs } from "../../constants/ApplicationConstants"
import { useDispatch, useSelector } from "react-redux"
import { setPageMessage,setProcessing } from "../../store/ApplicationStore"
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Tab, Tabs, Typography } from "@mui/material";
import { Article, AttachMoney, ContactSupport, DocumentScanner, ErrorOutline, InsightsOutlined, Person, PsychologyAlt, Quiz, Refresh, ThumbDown, ThumbUp, Timer } from "@mui/icons-material";
import { PieChart, BarChart } from "@mui/x-charts";
import { useHandleError } from "../others/ErrorScreen";
import PageLayout from "../../components/PageLayout";

const colorOfPlot=['rgb(184, 0, 216)',
    'rgb(46, 150, 255)',
    'rgb(96, 0, 155)',
    'rgb(39, 49, 200)',
    'rgb(3, 0, 141)',
    'rgb(2, 178, 175)',
    'rgb(50,50,50)',
    'rgb(200,100,100)']


export default function InsightsScreen(){
    const { menu } = useSelector(state => state.menu)
    const [ domain, setDomain ]= useState("");
    const [ time, setTime ]= useState(appConfigs.insightsOptions.default);
    const [adoptionMetrics,setAdoptionMetrics]=useState(null);
    const [userQueryPlot,setUserQueryPlot]=useState([]);
    const [queryPlot,setQueryPlot]=useState([]);
    const [piePlot,setPiePlot]=useState([]);
    
    const dispatch= useDispatch();
    const handleError=useHandleError()

    const fetchInsights= useCallback(async(domainId, timeFrame)=>{
        try{
            dispatch(setProcessing(true));
            const response= await postRequest(true, apiEndpoints.backendBaseURL+apiEndpoints.adminInsights, {
                "domain": domainId,
                "time": timeFrame
            });
            if(response.isError){
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "error"}));
            }else{
                response && response.data && response.data.nongraph && response.data.nongraph.length>0 &&  setAdoptionMetrics(response.data.nongraph[0]);
                response && response.data && response.data.graph && response.data.graph.adoption_rate_profile &&  setUserQueryPlot(response.data.graph.adoption_rate_profile);
                response && response.data && response.data.graph && response.data.graph.token_cost_latency_profile &&  setQueryPlot(response.data.graph.token_cost_latency_profile);
                response && response.data && response.data.graph && response.data.graph.feedback_profile 
                && response.data.graph.feedback_profile.every(item => item.value === 0) ?setPiePlot([]) :setPiePlot(response.data.graph.feedback_profile);              
                dispatch(setProcessing(false));
                dispatch(setPageMessage({message: response.message, type: "success"}));
            }
        }catch(err){
            handleError(err)
        }
    },[dispatch,handleError])

    useEffect(()=>{
        dispatch(setProcessing(true));
        if(menu){
            dispatch(setProcessing(false));
        }
    },[dispatch,menu])

    return(
        <PageLayout header footer>
            <Box>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Box>
                            <Box display='flex' >
                                <InsightsOutlined sx={{marginRight: '1rem'}}/>
                                <Stack direction='row' alignItems='center'>
                                <Box>
                                    <Typography variant='h5'>User Adoption Monitor</Typography>
                                    <Typography sx={{opacity: '0.6'}} variant='subtitle2'>Domain wise Insights of the User Activity.</Typography>
                                </Box>
                                <Refresh onClick={()=>fetchInsights(domain, time)} sx={{marginLeft: '1rem', opacity: 0.6, cursor:'pointer'}} />
                                </Stack>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={12} lg={12}>
                        <Grid container spacing={1}>
                            <Grid item sm={12} md={6} lg={3}>
                                <FormControl size='small' fullWidth>
                                    <InputLabel>Select Domain</InputLabel>
                                    <Select
                                    value={domain? domain : ""} label="Select Domain" onChange={(e)=>{setDomain(e.target.value); fetchInsights(e.target.value, time)}}>
                                        {menu&&menu.filter(item=> item.parent === "").map((obj)=>{
                                            return <MenuItem key={obj.id} value={obj.id}>{obj.name}</MenuItem>
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}></Grid>
                            <Grid item xs={6}>
                                <Tabs sx={{float: 'right',minHeight: '30px',
                                marginTop:'0.5rem',
                                height: '30px',
                                '& .MuiTab-root': {
                                minHeight: '30px',
                                height: '30px',
                                padding: '0px 12px',
                                textTransform: 'capitalize',
                                '&:hover': {
                                    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.5)',
                                },
                                transition: 'text-shadow 0.3s ease',
                                '& .MuiTab-labelIcon': {
                                    minHeight: '30px',
                                },
                                },
                                '& .MuiTabs-indicator': {
                                bottom: '0px',
                                }}} value={time} onChange={(event, newValue)=>{setTime(newValue); fetchInsights(domain, newValue)}} textColor="primary" indicatorColor="primary" >
                                    {appConfigs.insightsOptions.options.map(item=>{
                                        return <Tab disabled={!domain} label={item.label} value={item.time} key={item.time} />
                                    })}
                                </Tabs>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container sx={{boxShadow: 1, py:2, mt:1}} spacing={1}>
                            <Grid item xs={12} sm={12} md={3}>
                                <Grid container spacing={1}>
                                    <Grid item xs={1}>
                                        <PsychologyAlt fontSize='medium' color="secondary" />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Typography fontWeight='bold' color='grey'>Most Questions Asked By</Typography>
                                        <Typography fontWeight='bold' sx={{wordWrap:'break-word'}}>{adoptionMetrics && adoptionMetrics.max_qna_by_user? adoptionMetrics.max_qna_by_user:'NA'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}>
                                <Grid container spacing={1}>
                                    <Grid item xs={1}>
                                        <DocumentScanner fontSize='medium' color="success" />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Typography fontWeight='bold' color='grey'>Most Answers Retrieved From</Typography>
                                        <Typography fontWeight='bold' sx={{wordWrap:'break-word'}}>{adoptionMetrics && adoptionMetrics.docs_used ? adoptionMetrics.docs_used:'NA'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5}>
                                <Grid container spacing={1}>
                                    <Grid item xs={1}>
                                        <Quiz fontSize='medium' color="error" />
                                    </Grid>
                                    <Grid item xs={11}>
                                        <Typography fontWeight='bold' color='grey'>Most Asked Question</Typography>
                                        <Typography fontWeight='bold' sx={{wordWrap:'break-word'}}>{adoptionMetrics && adoptionMetrics.frequent_question_by_user? adoptionMetrics.frequent_question_by_user:'NA'}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={1} sx={{boxShadow: 1, py:2, mt:1}}>
                            <Grid item xs={12} sm={12} md={3}>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1}>
                                                <Person fontSize='medium' color="secondary" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Users</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.distinct_users_count:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1}>
                                                <Article fontSize='medium' color="success" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Documents</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.documents_count:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={5}>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1}>
                                                <ContactSupport fontSize='medium' color="secondary" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Queries</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.conversation_count:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1}>
                                                <Timer fontSize='medium' color="warning" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Avg. Latency(s)</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics && adoptionMetrics.avg_latency!==null && adoptionMetrics.avg_latency!=='' && adoptionMetrics.avg_latency!==undefined? adoptionMetrics.avg_latency:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1}>
                                                <AttachMoney fontSize='medium' color="success" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Avg. Cost($)</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics  && adoptionMetrics.avg_cost!==null && adoptionMetrics.avg_cost!==undefined && adoptionMetrics.avg_cost!==''? adoptionMetrics.avg_cost:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4}>
                                <Grid container spacing={1}>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1} sx={{marginRight:'2px'}}>
                                                <ThumbUp fontSize='medium' color="success" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Likes</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.likes:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1} sx={{marginRight:'2px'}}>
                                                <ThumbDown fontSize='medium' color="error" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>Dislikes</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.dislikes:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={1} sx={{marginRight:'2px'}}>
                                                <ErrorOutline fontSize='medium' color="warning" />
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography fontWeight='bold' color='grey'>No Feedback</Typography>
                                                <Typography fontWeight='bold'>{adoptionMetrics? adoptionMetrics.no_feedback:'NA'}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={0} sx={{boxShadow: 1, py:1, mt:1}}>
                            <Grid item xs={12} md={6} lg={4}>
                            {console.log("user barchart>>>>>>",userQueryPlot)}
                                <Box>
                                    <Typography align="center" fontWeight='bold'>Adoption Rate Profile</Typography>
                                    <BarChart
                                        dataset={
                                            userQueryPlot
                                        }
                                        slotProps={{
                                            legend: {
                                                hidden:userQueryPlot && userQueryPlot.length<=0
                                            },
                                            noDataOverlay: {
                                                message: 'No data to display', // Use the default no data message
                                            }
                                        }}          
                                        xAxis={[{ scaleType: 'band', dataKey: 'month', tick: () => null }]}
                                        series={[
                                            { dataKey: 'users', label: 'Users'},
                                            { dataKey: 'queries', label: 'Queries'},
                                        ]}
                                        {...{
                                            yAxis: [
                                            {
                                                label: 'Value',
                                                labelStyle: {
                                                    transform: 'translateX(-30px)' 
                                                },
                                            }                         
                                            ],
                                            height: 320,
                                            sx: {
                                                margin: '1.5rem',                                        
                                            },
                                        }}
                                    />
                                </Box>
                            </Grid>
                            {console.log("qquery bar chart>>>",queryPlot)}
                            <Grid item xs={12} md={6} lg={4}>
                                <Box>
                                    <Typography align="center" fontWeight='bold'>Average Cost,Latency and Tokens Profile</Typography>
                                    <BarChart
                                        dataset={queryPlot}
                                        slotProps={{                                    
                                            legend: {                                        
                                            direction: 'row',
                                            position: { vertical: 'top', horizontal: 'middle' },
                                            padding: -5,
                                            hidden:queryPlot && queryPlot.length<=0
                                            },
                                        }}
                                                                    
                                        xAxis={[{ scaleType: 'band', dataKey: 'month', tick: () => null }]}
                                        series={[
                                            { dataKey: 'cost', label: 'Avg. Cost($)'},
                                            { dataKey: 'latency', label: 'Avg. Latency(s)'},
                                            { dataKey: 'tokens', label: 'Avg. Tokens'},
                                        ]}
                                        {...{
                                            yAxis: [
                                            {
                                                label: 'Value',
                                                labelStyle: {
                                                    transform: 'translateX(-30px)' 
                                                },
                                            },
                                            ],                               
                                            height: 320,
                                            sx: {
                                                margin: '1.5rem',
                                            },
                                        }}
                                    />
                                </Box>
                            </Grid>
                            {console.log("pie chart>>>",piePlot)}
                            <Grid item xs={12} md={6} lg={4}>
                                <Box>
                                    <Typography align="center" fontWeight='bold'>Feedback Analyser</Typography>
                                    <PieChart height={320}
                                      sx={{ 
                                        "& .MuiChartsLegend-series text": { fontSize: "12px !important"},
                                        "& .MuiChartsLegend-mark": { width:15,height:15 },
                                        "& .MuiChartsLegend-column": {
                                           transform: "translateX(30px) !important" // Apply transform style to adjust position
                                         }
                                       }}
                                        slotProps={{
                                        legend: {
                                        direction: 'column',
                                        position: { vertical: 'middle', horizontal: 'right' },
                                        hidden:piePlot && piePlot.length<=0
                                        },
                                        noDataOverlay: {
                                            message: 'No data to display', 
                                            style: {                               
                                                transform:'translateX(12%)'                                  
                                            },
                                        },
                                    }}
                                        series={[
                                            { 
                                                data:piePlot.map((item, index) => ({
                                                ...item,
                                                color: colorOfPlot[index]
                                            })),
                                                innerRadius: 50, outerRadius: 80, paddingAngle: 0, cornerRadius: 5, startAngle: -90, endAngle: 270, cx: 80, cy: 150,
                                            }
                                        ]}                                   
                                    />
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </PageLayout>
    )
}